import { SettingsParser } from "../../../settings-parser";
import { getSizeSettings } from "../../../../../utils/get-size-settings";
import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { MeasurerSettings } from "../../../../settings/view-objects/plot/content/measurer-settings";

export class MeasurerPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    parsedSettings.leftPanelWidth = getSizeSettings(parsedSettings.leftPanelWidth, 0, 0);
    const colorFields = ["leftLineColor", "rightLineColor", "focusedAreaColor", "commonLabelColor", "intermediateAreaColor"];
    colorFields.forEach(colorField => {
      if (parsedSettings[colorField] !== undefined) {
        const parsedColor = ColorConverter.convertToWebglRgba(parsedSettings[colorField]);
        parsedSettings[colorField] = parsedColor.value;
      }
    });
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = MeasurerPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new MeasurerSettings(parsedSettings);
  }
}
